<template>
  <div :class="['wb_tool', courseSize]">
    <!--画笔-->
    <div
      :class="[active === 1 ? 'active' : '', 'pen', 'type']"
      @click="onSetToolType(1)"
    >
      <i class="icon"></i>
      画笔
    </div>
    <!--矩形-->
    <div
      :class="[active === 6 ? 'active' : '', 'rectangle', 'type']"
      @click="onSetToolType(6)"
    >
      <i class="icon"></i>
      矩形
    </div>
    <!--圆形-->
    <div
      :class="[active === 5 ? 'active' : '', 'round', 'type']"
      @click="onSetToolType(5)"
    >
      <i class="icon"></i>
      圆形
    </div>
    <!--直线-->
    <div
      :class="[active === 4 ? 'active' : '', 'line', 'type']"
      @click="onSetToolType(4)"
    >
      <i class="icon"></i>
      直线
    </div>
  </div>
</template>

<script>
export default {
  name: "WbTool",
  props: {
    active: {
      type: Number,
      default: 0
    },
    courseSize: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    onSetToolType(type) {
      this.$emit("onSetToolType", type);
    }
  }
};
</script>

<style lang="scss" scoped>
.wb_tool {
  position: absolute;
  left: 1.85vh;
  top: 1.85vh;
  width: 6.67vh;
  height: auto;
  background: #24252c;
  padding: 0.93vh 0;
  z-index: 12;
  .type {
    display: block;
    width: 100%;
    height: 7.96vh;
    box-sizing: border-box;
    padding: 0.93vh;
    text-align: center;
    font-size: 1.3vh;
    color: #eee;
    cursor: pointer;
    background: none;
    .icon {
      display: block;
      width: 3.7vh;
      height: 3.7vh;
      margin: 0 auto 1vh;
    }
    &.pen {
      .icon {
        background: url("../../../assets/images/live_room/icon_wb1.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &.rectangle {
      .icon {
        background: url("../../../assets/images/live_room/icon_wb2.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &.round {
      .icon {
        background: url("../../../assets/images/live_room/icon_wb3.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &.line {
      .icon {
        background: url("../../../assets/images/live_room/icon_wb4.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &:hover,
    &.active {
      color: #ffca4a;
      background: rgba(0, 0, 0, 0.21);
      &.pen {
        .icon {
          background: url("../../../assets/images/live_room/icon_wb1_s.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      &.rectangle {
        .icon {
          background: url("../../../assets/images/live_room/icon_wb2_s.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      &.round {
        .icon {
          background: url("../../../assets/images/live_room/icon_wb3_s.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      &.line {
        .icon {
          background: url("../../../assets/images/live_room/icon_wb4_s.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  &.maximize {
    background: rgba(36, 37, 44, 0.4);
    .type {
      .icon {
        opacity: 0.6;
      }
    }
  }
}
</style>
